import { render, staticRenderFns } from "./aromat-benzol.vue?vue&type=template&id=47f44875&"
import script from "./aromat-benzol.vue?vue&type=script&lang=js&"
export * from "./aromat-benzol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports